(function() { window.GUID_7b880868_ee39_4c4a_813f_62017fb7f40f = { getGuid: function() { return "7b880868-ee39-4c4a-813f-62017fb7f40f"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SnackbarType;
        (function (SnackbarType) {
            SnackbarType[SnackbarType["Danger"] = 0] = "Danger";
            SnackbarType[SnackbarType["Info"] = 1] = "Info";
            SnackbarType[SnackbarType["Success"] = 2] = "Success";
            SnackbarType[SnackbarType["Warning"] = 3] = "Warning";
        })(SnackbarType = Enumeration.SnackbarType || (Enumeration.SnackbarType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SnackbarType.pre.js.map
